// DuplicateWarningBanner — amber non-blocking warning banner shown in the
// approver's Review & Classify popup when the same (supplier GSTIN + invoice
// no) already exists in another module (Purchase / Petty cash / Expense claim).
// This is Layer 2 of duplicate bill detection. Layer 1 (hard block on same
// file hash) happens server-side at upload time.
export default function DuplicateWarningBanner({ matches, testid = "duplicate-warning-banner" }) {
    if (!matches || !matches.length) return null;
    const moduleLabel = (m) => ({
        purchase: "Purchase invoice",
        petty_cash: "Petty cash bill",
        expense_claim: "Expense claim",
    }[m] || m);
    return (
        <div className="border rounded-sm px-4 py-3 text-sm" data-testid={testid}
             style={{ background: "#fffbeb", borderColor: "#fbbf24", color: "#78350f" }}>
            <div className="font-medium flex items-center gap-2">
                <span aria-hidden="true">⚠</span> Possible duplicate — same supplier &amp; invoice already on file
            </div>
            <div className="text-[11px] mt-1 opacity-90">
                We found {matches.length} other {matches.length === 1 ? "entry" : "entries"} matching this supplier GSTIN
                and invoice number. Confirm this is a genuinely different bill before approving.
            </div>
            <ul className="mt-2 text-[11px] space-y-1">
                {matches.slice(0, 5).map((m) => (
                    <li key={`${m.module}-${m.id}`} className="flex flex-wrap gap-2 items-center">
                        <span className="px-1.5 py-0.5 rounded-sm bg-amber-100 border border-amber-300 text-amber-900 font-medium">
                            {moduleLabel(m.module)}
                        </span>
                        <span className="font-mono">#{m.code || (m.id || "").slice(0, 8)}</span>
                        <span>· {m.party_name}</span>
                        {m.invoice_no ? <span>· Inv {m.invoice_no}</span> : null}
                        {m.invoice_date ? <span>· {(m.invoice_date || "").slice(0, 10)}</span> : null}
                        <span>· ₹{Number(m.total || 0).toLocaleString("en-IN")}</span>
                        <span className="opacity-75">· by {m.submitted_by}</span>
                    </li>
                ))}
                {matches.length > 5 ? (
                    <li className="text-[11px] italic opacity-75">…and {matches.length - 5} more</li>
                ) : null}
            </ul>
        </div>
    );
}
